/* Gets a url paramater from query string */
export default function getUrlParameter(name) {
  const cleanName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  const regex = new RegExp(`[\\?&]${cleanName}=([^&#]*)`)
  const results = regex.exec(window.location.search)
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '))
}



// WEBPACK FOOTER //
// ./utilities/urlParams.util.js